var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"group-access"},_vm._l((_vm.groupIdList),function(groupId){return _c('div',{key:groupId},[_c('GroupAccessItem',{attrs:{"group-id":groupId}})],1)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }